import {
    GET_LEGALMATTERS_BY_CATEGORY,
    GET_LEGALMATTERS_BY_FILTER,
    GET_LEGALMATTERS_BY_ID,
} from './../actions/LegalMatterActions';

const initialState = {
    legalMatterListByCategory: {},
    legalMatterListByFilter: {},
    legalMatterDetail: {},
}

const LegalMatterReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LEGALMATTERS_BY_CATEGORY:
            return {
                ...state,
                legalMatterListByCategory: action.data
            }
        case GET_LEGALMATTERS_BY_FILTER:
            return {
                ...state,
                legalMatterListByFilter: action.data
            }
        case GET_LEGALMATTERS_BY_ID:
            return {
                ...state,
                legalMatterDetail: action.data
            }
        default:
            return state;
    }
}
export default LegalMatterReducer;
